import type { FaireProductEntity } from "../../entity_types/product";

export const p_ecnqa5pmhr: FaireProductEntity = {
  token: "p_ecnqa5pmhr",
  type: "product",
  name: "COZEE Knit Two Piece Lounge Short Set Hoodie With Shorts",
  brandToken: "b_xx7ucn4sqv",
  brandName: "TICTOC",
  imageUrl:
    "https://cdn.faire.com/fastly/d1bafca3922d70ebf2f06e114230d40363f6e6245bc60ee9f6457faf86753645.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c912d2d7072736b2d620eb76ec68583901cd969da98cc383a1def6f7b07af75a.jpeg",
    "https://cdn.faire.com/fastly/c64ecc01277899803e8c4118f437bb9612f0d31b9ed2e8165a950c2754309bee.jpeg",
    "https://cdn.faire.com/fastly/88808781359e9b7909d62ad321ddc6940db297a72e8695831c30c536bc37c63e.jpeg",
    "https://cdn.faire.com/fastly/781edfb7fdb6d1e0e94f40c1564f0f3381b99d7f1012a87bbe45cc276bfb7e1f.jpeg",
    "https://cdn.faire.com/fastly/fcf42a29f00bab83af5a034c4f9fcb150d9d57c4f8f79cdb177f55aa67a8abc6.jpeg",
    "https://cdn.faire.com/fastly/17203170fc8e7098e416de487d83a9f01c5e148716e62dec65cc8bd39b08d155.jpeg",
    "https://cdn.faire.com/fastly/0b7b2c5f3c61481d56416c6e9c6098a023051e489352b1f13a7cbe69b66fad4b.jpeg",
    "https://cdn.faire.com/fastly/22049645b9a3a79c3bbec01745e9fa405cb694f190a53bda8ae3fa0c70f98969.jpeg",
  ],
  priceDollars: 27.5,
  description:
    "COZEE Sweater Knit Two Piece Short Set \n Zip Up Hoodie With Drawstrings\nRibbed Cuffs and Waist \nKnitted Fold Over Waistband Shorties\nFigure Hugging Stretch Knit Fabric",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:10.057Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
